import $ from 'jquery';
import '@mockup/func/globals/App.util';
import { App } from './App';

export const tabs = {
    init: function () {
        this.normal();
        this.payment();
    },
    normal: function (scope, initialIndex = 0) {
        scope = scope ? scope + ' ' : '';

        var hashTabIndex = hash.get('tab');
        if (!initialIndex) {
            initialIndex = hashTabIndex ? hashTabIndex : 0;
        }

        $(scope + '.tabs').each(function () {
            var self = $(this);
            self.find('.tabs-list-item a').on('click', function () {
                var index = self.find('.tabs-list-item a').index($(this));

                self.find('.tabs-list-item a').removeClass('active');
                $(this).addClass('active');

                self.find('.tabs-item').hide();
                self.find($(this).attr('href')).show();

                changeState(index);

                return false;
            });

            if (self.find('.tabs-list-item a').length) {
                self.find('.tabs-list-item a').eq(initialIndex).click();
            }
        });

        function changeState(index) {
            if (index) {
                hash.add({ 'tab': index });
            } else if (hash.get('tab')) {
                hash.remove('tab');
            }

            if (typeof window.ga === 'function') {
                var locationHash = window.location.hash;

                if (locationHash === '#!') {
                    locationHash = '';
                }

                var location = window.location.protocol + '//' + window.location.hostname + window.location.pathname + window.location.search + locationHash;

                if (typeof window.ga === 'function') {
                    window.ga('send', {
                        'hitType': 'pageview',
                        'page': location
                    });
                }
            }
        }

    },
    payment: function (scope) {
        scope = scope ? scope + ' ' : '';
        $(scope + '.tabs-payment li').on('click', function () {
            $(scope + '.tabs-payment li').removeClass('current');
            $(this).addClass('current');

            var cIndex = $(this).index();

            $(scope + '.table-payout table:first td').removeClass('current');
            $(scope + '.table-payout table:first tr:visible').each(function () {
                $(this).find('td.invisible').eq(cIndex).addClass('current');
            });

            $(scope + '.tip:visible').trigger('click');

            return false;
        });
    }
};

export default tabs;

App.Util.tabs = tabs;
